import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // A wrong password also answers 401: let the login page show the message.
    const isLogin = (err.config?.url || '').includes('/auth/login');
    if (err.response?.status === 401 && !isLogin) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
};

export const devicesAPI = {
  update: (id, data) => api.put(`/devices/${id}`, data),
  list: () => api.get('/devices'),
  create: (data) => api.post('/devices', data),
  delete: (id) => api.delete(`/devices/${id}`),
  syncBoxes: (id) => api.post(`/devices/${id}/sync-boxes`),
  checkStatus: (id) => api.post(`/devices/${id}/check-status`),
  getBoxes: (id) => api.get(`/devices/${id}/boxes`),
  openBox: (deviceId, boxId) => api.post(`/devices/${deviceId}/boxes/${boxId}/open`),
  syncDoorStatus: (id) => api.post(`/devices/${id}/sync-door-status`),
  getBoxesDetail: (id) => api.get(`/devices/${id}/boxes-detail`),
  markBoxClosed: (deviceId, boxId) => api.post(`/devices/${deviceId}/boxes/${boxId}/mark-closed`),
  forceRelease: (deviceId, boxId) => api.post(`/devices/${deviceId}/boxes/${boxId}/force-release`),
  checkAllStatus: () => api.post("/devices/check-all-status"),
  autoSync: (id) => api.post(`/devices/${id}/auto-sync`),
};

export const ordersAPI = {
  list: (status) => api.get('/orders', { params: status ? { status } : {} }),
  create: (data) => api.post('/orders', data),
  get: (id) => api.get(`/orders/${id}`),
  checkin: (id) => api.post(`/orders/${id}/checkin`),
  checkout: (id) => api.post(`/orders/${id}/checkout`),
  cancel: (id) => api.delete(`/orders/${id}`),
  assignBox: (orderId, boxId) => api.post(`/orders/${orderId}/assign-box?box_id=${boxId}`),
};

export const paymentsAPI = {
  status: (id) => api.get(`/payments/status/${id}`),
};

export const adminAPI = {
  revenueSummary: (days = 30) => api.get(`/admin/revenue/summary?days=${days}`),
  dashboard: () => api.get('/admin/dashboard'),
  users: () => api.get('/admin/users'),
  setUserRole: (userId, role) => api.put(`/admin/users/${userId}/role?role=${encodeURIComponent(role)}`),
  resendSms: (userId) => api.post(`/admin/users/${userId}/resend-sms`),
  toggleUser: (userId) => api.put(`/admin/users/${userId}/toggle`),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  pricing: () => api.get('/admin/pricing'),
  createPricing: (data) => api.post('/admin/pricing', data),
  deletePricing: (id) => api.delete(`/admin/pricing/${id}`),
  logs: (limit = 50) => api.get('/admin/logs', { params: { limit } }),
  dashboardExtended: () => api.get('/admin/dashboard-extended'),
  liveLockers: () => api.get('/admin/live-lockers'),
  alerts: () => api.get('/admin/alerts'),
  parcelHistory: (params = {}) => api.get('/admin/parcel-history', { params }),
  boxHistory: (device_number, box_name) => api.get(`/admin/box-history/${device_number}/${box_name}`),
};

export default api;
